import { Schema } from "effect";

export const ChannelThreadAnalyticsHandoffSource = Schema.Literal(
  "tool-call",
  "handoff-detection",
);
export type ChannelThreadAnalyticsHandoffSource =
  typeof ChannelThreadAnalyticsHandoffSource.Type;
